import React, { useCallback, useEffect, useRef, useState } from "react";
import "../../../features/assessment/styles/AssessementQuestionPage_Styles.css";
import { useNavigate } from "react-router-dom";
import Popup from "../../../components/PopUpDesign";
import AlertPopup from "../../../components/AlertPopUp";
import { useApi } from "../../../service/ApiContext";
import { LocalStorage } from "../../../utils/Utils";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import { clearAssessment } from "../data/redux/AssessmentSlice";
import {
  logActionEvent,
  logPageView,
} from "../../../analytics/analytics_utils";
import strings from "../../../utils/Strings";
import analytics_strings from "../../../analytics/analytics_strings";
import { useCamera } from "./CameraContext";
import { LogOutResponse } from "../../../features/sideBar/data/response/LogOut_Response";
import AssessmentQuestionModuleClient from "../data/ApiClient/AssessmentQuestionModuleClient";
import AssessmentFeedbackComponent from "../../../features/assessment/components/AssessmentFeedbackComponent";
import AssessmentQuestionModuleApiService from "../../assessment_question/data/api_services/QuestionModuleApi";
import AssessmentQuestionPage from "../../assessment_question/pages/AssessmentQuestionPage";
import { useProctoring } from "../../assessment_activeproctoring/hooks/ActiveProctoringContext";

import { useFaceDetection } from "../../assessment_activeproctoring/hooks/useFaceDetection";
import { useObjectDetection } from "../../assessment_activeproctoring/hooks/useObjectDetection";
import ViolationOverlays from "../../assessment_activeproctoring/component/ViolationOverlay";
import { createPortal } from "react-dom";
const NORMAL_API_INTERVAL_MS = 5000; // 5 seconds normal
const INTENSIVE_API_INTERVAL_MS = 2000; // 2 seconds intensive
const INTENSIVE_MODE_DURATION_MS = 60000; // 1 minute intensive mode
type MalpracticeType =
  | "multiple_faces"
  | "head_position"
  | "looking_away"
  | "no_face"
  | "inactivity"
  | "prohibited_object"
  | "api_malpractice";
interface ProctorAPIResponse {
  malpractice_detected: boolean;
  details: string | null;
}
interface AssessmentNewWindowComponentProps {
  selectedAssessment: any;
  data: {
    name: string;
    age: number;
  };
  isHalfSize: boolean;
  isChildWindowOpen: boolean;
  setIsChildWindowOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setIsPopupVisible: React.Dispatch<React.SetStateAction<boolean>>;
  isPopupVisible: boolean;
  isForcedExit: boolean;
  setIsForcedExit: React.Dispatch<React.SetStateAction<boolean>>;
  //assessmentWindow: Window | null;
}
// ─── Malpractice Popup Component ──────────────────────────────────────────────────
const MalpracticePopup: React.FC<{
  type: MalpracticeType;
  detectedObjects?: string[];
  details?: string;
  onDismiss: () => void;
  autoDismiss?: boolean;
  // targetDocument: Window | null;
}> = ({
  type,
  detectedObjects = [],
  details,
  onDismiss,
  autoDismiss = true,
  // targetDocument,
}) => {
  useEffect(() => {
    if (autoDismiss) {
      const timer = setTimeout(() => {
        onDismiss();
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [autoDismiss, onDismiss]);
  const getMessage = () => {
    switch (type) {
      case "multiple_faces":
        return {
          title: "⚠️ Multiple Faces Detected",
          message:
            "Only one person should be visible during the interview. Please ensure you are alone in the room.",
          icon: "👥",
        };
      case "head_position":
        return {
          title: "⚠️ Incorrect Head Position",
          message:
            "Please face the camera directly and keep your head straight.",
          icon: "🎯",
        };
      case "looking_away":
        return {
          title: "⚠️ Looking Away Detected",
          message:
            "Please maintain eye contact with the camera during the interview.",
          icon: "👁️",
        };
      case "no_face":
        return {
          title: "⚠️ Face Not Detected",
          message: "Please ensure your face is clearly visible to the camera.",
          icon: "😕",
        };
      case "inactivity":
        return {
          title: "⚠️ Inactivity Detected",
          message: "Please interact with the interview to continue.",
          icon: "⏰",
        };
      case "prohibited_object":
        const objectList = detectedObjects.join(", ");
        return {
          title: "⚠️ Prohibited Object Detected",
          message: `Please remove prohibited items (${objectList}) from your interview environment.`,
          icon: "📱",
        };
      case "api_malpractice":
        return {
          title: "⚠️ Malpractice Detected",
          message:
            details ||
            "Suspicious activity detected. Please follow the interview guidelines.",
          icon: "🚨",
        };
      default:
        return {
          title: "⚠️ Warning",
          message: "Please follow the interview guidelines.",
          icon: "⚠️",
        };
    }
  };

  const { title, message, icon } = getMessage();
  // const portalDocument = targetDocument ?? window.document;
  //createPortal
  return (
    <div className="malpractice-snackbar-container">
      <div
        className="malpractice-snackbar-toast"
        role="alert"
        aria-live="assertive"
      >
        <div className="malpractice-snackbar-toast-icon">{icon}</div>

        <div className="malpractice-snackbar-toast-content">
          <h3 className="malpractice-snackbar-toast-title">{title}</h3>

          <p className="malpractice-snackbar-toast-message">{message}</p>
        </div>

        <button
          type="button"
          onClick={onDismiss}
          className="malpractice-snackbar-toast-close"
          aria-label="Dismiss notification"
        >
          &times;
        </button>
      </div>
    </div>
    // ,
    // targetDocument?.document.body ?? window.document.body,
  );
  // return (

  //   <div className="malpractice-popup-overlay">
  //     <div className="malpractice-popup">
  //       <div className="malpractice-popup-icon">{icon}</div>
  //       <h3>{title}</h3>
  //       <p>{message}</p>
  //       <button onClick={onDismiss} className="malpractice-popup-button">
  //         I Understand
  //       </button>
  //     </div>
  //   </div>
  // );
};

const AssessmentNewWindowComponent: React.FC<
  AssessmentNewWindowComponentProps
> = ({
  selectedAssessment,
  data,
  isHalfSize,
  isChildWindowOpen,
  setIsChildWindowOpen,
  isForcedExit,
  isPopupVisible,
  setIsPopupVisible,
  setIsForcedExit,
  // assessmentWindow,
}) => {
  // const toastContainer = assessmentWindow;
  const [isFeedbackVisible, setIsFeedbackVisible] = useState(false);
  const questionModuleApiService = AssessmentQuestionModuleApiService(); //API Service Class for question module
  const { stopCamera } = useCamera();
  // Select the data from the Redux store
  const userData = useSelector((state: RootState) => state.profile.profileKeys);
  // Check if window is resized
  useEffect(() => {
    if (isHalfSize) {
      alert("The window is resized to less than half the screen size.");
    }
  }, [isHalfSize]);
  const navigate = useNavigate();
  const api = useApi();
  const dispatch = useDispatch();
  // Malpractice state
  const [malpracticePopup, setMalpracticePopup] = useState<{
    show: boolean;
    type: MalpracticeType;
    detectedObjects?: string[];
    details?: string;
  }>({
    show: false,
    type: "no_face",
  });
  const [malpracticeCount, setMalpracticeCount] = useState<
    Record<MalpracticeType, number>
  >({
    multiple_faces: 0,
    head_position: 0,
    looking_away: 0,
    no_face: 0,
    inactivity: 0,
    prohibited_object: 0,
    api_malpractice: 0,
  });
  //Active Proctoring
  const {
    stopProctoring,
    setupStep,
    setSetupStep,
    startCameraSetup,
    setIsProctoringActive,
    cameraStream,
    permissionDenied,
    screenPermissionDenied,
  } = useProctoring();

  const isCameraRequired = (() => {
    const propVal = selectedAssessment?.is_camera_required;
    if (typeof propVal === "boolean") return propVal;
    if (typeof propVal === "string")
      return propVal.toLowerCase() === "true" || propVal === "1";
    if (typeof propVal === "number") return propVal === 1;

    const localVal = LocalStorage.getLocalData(
      strings.localStorage_keys.assessment_details.is_camera_required,
    );
    if (localVal !== null && localVal !== undefined && localVal !== "") {
      return (
        localVal.toString().toLowerCase() === "true" ||
        localVal.toString() === "1"
      );
    }
    return true; // Default fallback
  })();

  useEffect(() => {
    // When assessment window is open, proctoring is active and ready
    setSetupStep("ready");
    setIsProctoringActive(true);

    if (!cameraStream && isCameraRequired) {
      startCameraSetup();
    }
    // Return a cleanup function
    return () => {
      if (isFeedbackVisible === false) {
        questionModuleApiService.clearAssessmentLocalStorage();
        navigate("/dashboard/student");
        //Closing Assessment Camera
        stopCamera();
        setIsProctoringActive(false);
        stopProctoring();
        window.location.reload();
      }
    };
  }, [cameraStream, isCameraRequired]);
  useEffect(() => {
    if (isForcedExit) {
      const timer = setTimeout(() => {
        assessmentLogout();
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [isForcedExit]);

  const closePopup = () => {
    setIsPopupVisible(false);
  };
  const closeNetworkPopup = () => {
    setIsPopupVisible(false);
    navigate("/dashboard/assessment");
  };
  const closeInfoPopup = () => {
    setIsForcedExit(false);
    assessmentLogout();
  };
  const assessmentId = useSelector(
    (state: RootState) => state.assessment.assessmentId,
  );
  const effectiveAssessmentId =
    assessmentId ||
    selectedAssessment?.assessment_id ||
    selectedAssessment?.assessment_entity_id ||
    LocalStorage.getLocalData(
      strings.localStorage_keys.assessment_details.assessment_id,
    ) ||
    LocalStorage.getLocalData(
      strings.localStorage_keys.assessment_details.assessment_entity_id,
    );
  const assessmentLogout = async () => {
    logActionEvent(analytics_strings.analytics_events.assessmentLogoutButton, {
      candidate_id: userData.candidate_id,
    });
    api.setAuthToken(LocalStorage.getLocalData("access_token"));
    try {
      await api
        .post<LogOutResponse>(
          `${AssessmentQuestionModuleClient.logout}?assessment_id=${assessmentId}`,
        )
        .then((res) => {
          if (res?.data?.error === null) {
            dispatch(clearAssessment());
            setIsChildWindowOpen(false);
          }
        })
        .catch((error) => {});
    } catch (error) {
    } finally {
    }
  };
  //Active Proctoring
  const isDetectionActive =
    Boolean(cameraStream) && !permissionDenied && !screenPermissionDenied;

  const {
    isFaceDetected,
    isMultiFaceDetected,
    isPositionWrong,
    positionWarning,
  } = useFaceDetection(cameraStream, isDetectionActive);
  const { isObjectDetected, detectedObjects } = useObjectDetection(
    cameraStream,
    isDetectionActive,
  );

  // Restricted object detection warning and Auto-Submit
  const detectedObjectsStr = detectedObjects.join(", ");

  // Monitor camera hardware status (detecting if candidate shuts or turns off camera)
  const [isCameraOff, setIsCameraOff] = useState(false);

  useEffect(() => {
    // If camera is not required and no camera is active, do not trigger camera off violation
    if (!isCameraRequired && !cameraStream) {
      setIsCameraOff(false);
      return;
    }

    if (!cameraStream) {
      if (isCameraRequired) {
        setIsCameraOff(true);
      }
      return;
    }

    const videoTracks = cameraStream.getVideoTracks();
    if (videoTracks.length === 0) {
      if (isCameraRequired) {
        setIsCameraOff(true);
      }
      return;
    }

    const track = videoTracks[0];
    const updateTrackStatus = () => {
      const isOff =
        !track.enabled || track.muted || track.readyState === "ended";
      setIsCameraOff(isOff);
    };

    updateTrackStatus();

    track.addEventListener("ended", updateTrackStatus);
    track.addEventListener("mute", updateTrackStatus);
    track.addEventListener("unmute", updateTrackStatus);

    const interval = setInterval(updateTrackStatus, 1000);

    return () => {
      track.removeEventListener("ended", updateTrackStatus);
      track.removeEventListener("mute", updateTrackStatus);
      track.removeEventListener("unmute", updateTrackStatus);
      clearInterval(interval);
    };
  }, [cameraStream, isCameraRequired]);

  // ===============================
  // Plugin  DETECTION DEBUG
  // ===============================

  useEffect(() => {
    // console.log("@@  Debug is_critical", {
    //   isFaceDetected,
    //   isMultiFaceDetected,
    //   isObjectDetected,
    //   isPositionWrong,
    // });
  }, [isFaceDetected, isObjectDetected, isMultiFaceDetected, isPositionWrong]);

  //Api Proctoring State
  // Proctor API state
  const [isIntensiveMode, setIsIntensiveMode] = useState(false);
  const intensiveModeTimerRef = useRef<NodeJS.Timeout | null>(null);
  const apiIntervalRef = useRef<NodeJS.Timeout | null>(null);
  // ===============================
  // Hidden Video Ref For API Capture
  // ===============================

  const videoElement = useRef<HTMLVideoElement>(null);

  // ===============================
  // Attach Stream To Hidden Video
  // ===============================

  useEffect(() => {
    if (videoElement.current && cameraStream) {
      videoElement.current.srcObject = cameraStream;

      videoElement.current
        .play()
        .then(() => {
          // console.log("@@ Hidden video started");
        })
        .catch((err) => {
          // console.error("@@ Hidden video play failed", err);
        });
    } else if (videoElement.current && !cameraStream) {
      videoElement.current.srcObject = null;
    }
  }, [cameraStream]);

  // ===============================
  // Capture Frame As Blob
  // ===============================

  // ===============================
  // Capture Frame As Blob (Camera or Fallback)
  // ===============================

  const captureFrameAsBlob = useCallback((): Promise<Blob | null> => {
    return new Promise((resolve) => {
      // 1. If cameraStream is active, capture from video
      if (cameraStream) {
        const video = videoElement.current;
        if (
          video &&
          video.readyState >= 2 &&
          video.videoWidth > 0 &&
          video.videoHeight > 0
        ) {
          try {
            const canvas = document.createElement("canvas");
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            const ctx = canvas.getContext("2d");
            if (ctx) {
              ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
              canvas.toBlob(
                (blob) => {
                  if (blob) {
                    resolve(blob);
                    return;
                  }
                  fallbackCameraCapture();
                },
                "image/jpeg",
                0.8,
              );
              return;
            }
          } catch (err) {
            console.warn("Direct frame capture failed, trying fallback:", err);
          }
        }

        fallbackCameraCapture();
        return;
      }

      // 2. Camera is not on / disabled: generate proctor frame so Proctor API can still be called
      try {
        const canvas = document.createElement("canvas");
        canvas.width = 640;
        canvas.height = 480;
        const ctx = canvas.getContext("2d");
        if (ctx) {
          ctx.fillStyle = "#1e1e1e";
          ctx.fillRect(0, 0, 640, 480);
          ctx.fillStyle = "#9ca3af";
          ctx.font = "bold 20px sans-serif";
          ctx.textAlign = "center";
          ctx.fillText("Camera Off", 320, 230);
          ctx.font = "14px sans-serif";
          ctx.fillText("Active Proctoring Session", 320, 260);
          canvas.toBlob(
            (blob) => {
              resolve(blob);
            },
            "image/jpeg",
            0.8,
          );
          return;
        }
      } catch (e) {
        console.warn("Failed to generate fallback proctor frame:", e);
      }
      resolve(null);

      function fallbackCameraCapture() {
        try {
          const tempVideo = document.createElement("video");

          tempVideo.srcObject = cameraStream;
          tempVideo.muted = true;
          tempVideo.playsInline = true;
          tempVideo.autoplay = true;

          const cleanup = () => {
            tempVideo.pause();
            tempVideo.srcObject = null;
          };

          const timeout = setTimeout(() => {
            cleanup();
            resolve(null);
          }, 3000);

          tempVideo.onloadedmetadata = async () => {
            try {
              await tempVideo.play();
              clearTimeout(timeout);

              if (
                tempVideo.readyState < 2 ||
                tempVideo.videoWidth === 0 ||
                tempVideo.videoHeight === 0
              ) {
                cleanup();
                resolve(null);
                return;
              }

              const canvas = document.createElement("canvas");
              canvas.width = tempVideo.videoWidth;
              canvas.height = tempVideo.videoHeight;
              const ctx = canvas.getContext("2d");

              if (!ctx) {
                cleanup();
                resolve(null);
                return;
              }

              ctx.drawImage(tempVideo, 0, 0, canvas.width, canvas.height);

              canvas.toBlob(
                (blob) => {
                  cleanup();
                  resolve(blob);
                },
                "image/jpeg",
                0.8,
              );
            } catch (err) {
              clearTimeout(timeout);
              cleanup();
              resolve(null);
            }
          };

          tempVideo.onerror = () => {
            clearTimeout(timeout);
            cleanup();
            resolve(null);
          };
        } catch (error) {
          resolve(null);
        }
      }
    });
  }, [cameraStream]);

  // ===============================
  // Proctor API Call (Runs Whether Camera Is On Or Off)
  // ===============================

  const callProctorAPI = useCallback(async () => {
    if (!effectiveAssessmentId) {
      return;
    }

    const frameBlob = await captureFrameAsBlob();

    if (!frameBlob) {
      return;
    }

    const timestamp = new Date().toISOString();

    try {
      const formData = new FormData();

      formData.append("file", frameBlob, `frame_${timestamp}.jpg`);

      const response = await api.post("/proctor/upload-frame", formData, {
        params: {
          session_id: effectiveAssessmentId,
          timestamp,
          is_assessment: true,
          // is_camera_on: Boolean(cameraStream),
          // is_camera_required: isCameraRequired,
        },
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      const data = response.data as ProctorAPIResponse;

      if (data.malpractice_detected) {
        // If camera is not required and camera is off, ignore face/camera missing alerts
        const isFaceMalpractice =
          data.details?.toLowerCase().includes("face") ||
          data.details?.toLowerCase().includes("camera");
        if (!isCameraRequired && !cameraStream && isFaceMalpractice) {
          return;
        }

        // Show popup with API response details
        setMalpracticePopup({
          show: true,
          type: "api_malpractice",
          details: data.details || "Suspicious activity detected",
        });
        setMalpracticeCount((prev) => ({
          ...prev,
          api_malpractice: prev.api_malpractice + 1,
        }));

        if (!isIntensiveMode) {
          setIsIntensiveMode(true);

          // Clear old interval
          if (apiIntervalRef.current) {
            clearInterval(apiIntervalRef.current);
            apiIntervalRef.current = null;
          }

          // Clear previous timer
          if (intensiveModeTimerRef.current) {
            clearTimeout(intensiveModeTimerRef.current);
          }

          // Start intensive timer
          intensiveModeTimerRef.current = setTimeout(() => {
            setIsIntensiveMode(false);
            intensiveModeTimerRef.current = null;
          }, INTENSIVE_MODE_DURATION_MS);

          // Auto-dismiss popup after 5 seconds
          setTimeout(() => {
            setMalpracticePopup((prev) => ({ ...prev, show: false }));
          }, 5000);
        }
      }
    } catch (error) {
      console.error("Proctor API failed:", error);
    }
  }, [
    effectiveAssessmentId,
    cameraStream,
    isCameraRequired,
    captureFrameAsBlob,
    api,
    isIntensiveMode,
  ]);

  // ===============================
  // Setup API Interval
  // ===============================

  const setupApiInterval = useCallback(() => {
    // Clear previous interval
    if (apiIntervalRef.current) {
      clearInterval(apiIntervalRef.current);
      apiIntervalRef.current = null;
    }

    const intervalMs = isIntensiveMode
      ? INTENSIVE_API_INTERVAL_MS
      : NORMAL_API_INTERVAL_MS;

    // Immediately trigger frame call whether camera is on or off
    callProctorAPI();

    apiIntervalRef.current = setInterval(() => {
      callProctorAPI();
    }, intervalMs);
  }, [callProctorAPI, isIntensiveMode]);

  // ===============================
  // Start Monitoring (Whether Camera Is On Or Off)
  // ===============================

  useEffect(() => {
    setupApiInterval();

    return () => {
      if (apiIntervalRef.current) {
        clearInterval(apiIntervalRef.current);
        apiIntervalRef.current = null;
      }

      if (intensiveModeTimerRef.current) {
        clearTimeout(intensiveModeTimerRef.current);
        intensiveModeTimerRef.current = null;
      }
    };
  }, [setupApiInterval]);

  return (
    <div style={{ height: "100%" }}>
      {/* Offline Alert */}
      {/* <Offline>
        <Popup
          title="Info"
          body="The system has detected that there is no internet connection. Don’t worry! Please close the window and resume the assessment when you're ready."
          onClose={closeNetworkPopup}
        />
      </Offline> */}

      {/* Malpractice Popup */}
      {malpracticePopup.show && (
        <MalpracticePopup
          type={malpracticePopup.type}
          detectedObjects={malpracticePopup.detectedObjects}
          details={malpracticePopup.details}
          onDismiss={() =>
            setMalpracticePopup({ show: false, type: "no_face" })
          }
          // targetDocument={toastContainer}
        />
      )}
      {/* <ViolationOverlays
          showPositionWarning={Boolean(cameraStream) && isPositionWrong}
          positionWarningMessage={positionWarning || ""}
          showFaceWarning={
            Boolean(cameraStream)
              ? !isFaceDetected
              : isCameraRequired
          }
          showObjectWarning={Boolean(cameraStream) && isObjectDetected}
          detectedObjectsStr={detectedObjectsStr}
          showMultiFaceWarning={Boolean(cameraStream) && isMultiFaceDetected}
          showCameraOffWarning={isCameraOff}
        />*/}
      {/* Hidden video element keeping camera stream active for instant frame capture */}
      <video
        ref={videoElement}
        autoPlay
        playsInline
        muted
        style={{
          position: "fixed",
          bottom: 0,
          right: 0,
          width: "1px",
          height: "1px",
          opacity: 0.01,
          pointerEvents: "none",
          zIndex: -1,
        }}
      />
      {/* Popup for tab visibility change */}
      {isPopupVisible && isFeedbackVisible === false && (
        <AlertPopup
          title="Alert"
          body=" Your assessment will be invalidated if you tab
              out or close the browser. Please make sure that you are on the
              assessment screen."
          onClose={closePopup}
        />
      )}
      {/* pop up for limit exceeds */}
      {isForcedExit && isFeedbackVisible === false && (
        <Popup
          title="Info"
          body="You are being logged out of this assessment as you have moved to other windows 3 times. This assessment will be discarded and not evaluated."
          onClose={closeInfoPopup}
        />
      )}
      {!navigator.onLine && (
        <Popup
          title="Info"
          body="The system has detected that there is no internet connection. Don’t worry! Please close the window and resume the assessment when you're ready."
          onClose={closeNetworkPopup}
        />
      )}
      {isFeedbackVisible ? (
        <AssessmentFeedbackComponent
          setIsChildWindowOpen={setIsChildWindowOpen}
        />
      ) : (
        <div className="assessment-question-background">
          <AssessmentQuestionPage
            selectedAssessment={selectedAssessment}
            setIsFeedbackFormVisible={setIsFeedbackVisible}
            isFeedbackVisible={isFeedbackVisible}
            isChildWindowOpen={isChildWindowOpen}
            setIsChildWindowOpen={setIsChildWindowOpen}
          />
        </div>
      )}
    </div>
  );
};

export default AssessmentNewWindowComponent;
